__webpack_require__.p = "https://ikea.marat.qd.je/ch/de/customer-service/support/";